import { setRemoteDefinitions } from '@nx/angular/mf';
import { ENVIRONMENT } from '@sbg-web/env';
import { SBSA_FEATURES } from '@sbg-web/sbsa/feature-flags';
import { init as initApm } from '@elastic/apm-rum';

// Initialize Elastic APM RUM Agent (gated by SBSA_FEATURES.elasticRumMonitoring)
const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
if (SBSA_FEATURES.elasticRumMonitoring && ENVIRONMENT.rum && !isLocalhost) {
    try {
        const rumConfig = ENVIRONMENT.rum;
        const rumEnvironment = ENVIRONMENT.prod ? 'PROD' : ENVIRONMENT.uat || ENVIRONMENT.sit ? 'SIT' : 'DEV';
        const apm = initApm({
            serviceName: rumConfig.serviceName,
            serverUrl: rumConfig.serverUrl,
            serviceVersion: rumConfig.serviceVersion,
            environment: rumEnvironment,
            active: true,
            logLevel: rumConfig.logLevel,
            transactionSampleRate: rumConfig.transactionSampleRate,
            distributedTracingOrigins: [window.location.origin, rumConfig.serverUrl],
            pageLoadTransactionName: window.location.pathname,
            propagateTracestate: true,
            breakdownMetrics: true,
            centralConfig: true
        });

        // Expose APM agent on window for console debugging (non-prod only)
        if (rumEnvironment !== 'PROD') {
            (window as any).__apm = apm;
        }
    } catch (err) {
        console.error('Elastic APM RUM failed to initialise', err);
    }
}

interface AppConfigResponse {
    status: 'success' | 'error';
    config: any;
    error?: Error;
}

async function getSiteConfig(baseUrl: string): Promise<AppConfigResponse> {
    try {
        const response = await fetch(`${baseUrl}appconfig.json`);
        if (response.ok) {
            const config = await response.json();
            return { status: 'success', config };
        }
        const defaultConfig = await fetch(`/assets/${ENVIRONMENT.manifest}`);
        const defaultConfigJson = await defaultConfig.json();

        return Promise.resolve({
            status: 'error',
            config: defaultConfigJson,
            error: new Error(`Response status: ${response.status}`)
        });
    } catch (err) {
        const defaultConfig = await fetch(`/assets/${ENVIRONMENT.manifest}`);
        const defaultConfigJson = await defaultConfig.json();
        return Promise.resolve({ status: 'error', config: defaultConfigJson, error: err as Error });
    }
}

getSiteConfig(`${ENVIRONMENT.siteConfigUrl}`)
    .then((configResponse: AppConfigResponse) => {
        configResponse.status === 'success'
            ? console.log('Config loaded successfully')
            : console.error('Failed to load dynamic config, using default config');

        // adding the siteConfig to the window {}
        (window as any).siteConfig = configResponse;

        return setRemoteDefinitions(configResponse.config.manifest);
    })
    // TODO Add an error check here
    .then(() => import('./bootstrap').catch((err) => console.error(err)));
